import { cpReturnOrderDetailApi } from '@apis/cp/orders.js';
import { returnOrderDetailApi } from '@apis/seller-center/orders';
import { Button, Modal, Status, Toast } from '@common-web/index.js';
import { strings } from '@constants/strings.js';
import { useGetRequest } from '@hooks/index.js';
import { isCP } from '@utils/app-utils';
import { getErrorString } from '@utils/utils.js';
import { Flex } from 'antd';
import { FaCheckCircle } from 'react-icons/fa';
import ReturnOrderDetailModalBody from './return-order-detail-modal-body';

const ReturnOrderDetailModal = (props) => {
  const {
    open,
    setOpen,
    returnOrderId,
    openRefundModal = () => {},
    setConfirmationModal = () => {},
    handleReturnOrderAction = () => {},
  } = props;

  const getReturnOrderDetail = async () => {
    try {
      const apiCall = isCP() ? cpReturnOrderDetailApi : returnOrderDetailApi;
      const res = await apiCall(returnOrderId);
      if (res.success) {
        return {
          ...res.return,
          possible_actions: res.possible_actions,
        };
      }
    } catch (e) {
      Toast.error(getErrorString(e));
    }
  };

  const { data: returnOrderDetail, loading } = useGetRequest({
    key: [`returnOrderDetail${returnOrderId}`, returnOrderId],
    fetch: () => getReturnOrderDetail(),
    enabled: !!returnOrderId,
  });

  const handleCancel = async () => {
    setOpen(false);
  };

  const handleDynamicAction = async (action) => {
    if (action?.required_attributes?.refund_proof_attributes?.is_required) {
      openRefundModal({ ...returnOrderDetail, action });
      setOpen(false);
    } else {
      setOpen(false);
      setConfirmationModal({
        title: action?.name,
        body: () => (
          <div>
            <Flex vertical gap={12}>
              <div>{strings.are_you_sure_perform_action}</div>
              <Flex align="center" gap={8}>
                <FaCheckCircle color="var(--ant-color-success" size={14} />
                <span className="fw-600">
                  {' '}
                  {strings.order_id} {returnOrderDetail?.id}
                </span>
              </Flex>
            </Flex>
          </div>
        ),
        action: () => handleReturnOrderAction(action, returnOrderDetail),
      });
    }
  };

  const possibleActions = returnOrderDetail?.possible_actions || [];

  return (
    <Modal
      open={open}
      title={
        <Flex align={'center'} gap={8}>
          <span>{strings.return_order_details}</span>
          {returnOrderDetail?.status?.name && <Status name={returnOrderDetail?.status?.name} />}
        </Flex>
      }
      ModalBody={<ReturnOrderDetailModalBody returnOrder={returnOrderDetail} loading={loading} />}
      closable={true}
      handleCancel={handleCancel}
      showCustomFooter={possibleActions?.length}
      customFooter={possibleActions?.map((action) => (
        <Button
          key={`action-${action?.slug}`}
          type="primary"
          onClick={() => handleDynamicAction(action)}
          disabled={loading}
        >
          {action?.name}
        </Button>
      ))}
      modalStyles={{
        height: '500',
        overflow: 'auto',
      }}
      width={720}
    />
  );
};

export default ReturnOrderDetailModal;
